

const CustomerCreationProcess = ({ orderDetails, payment, completeOrder }) => {
    return (
      <>
          <section className="order-process-container">
              <div className="flex flex-row gap-8">
                  <div className="order-process-content">
                      <div className={orderDetails ? 'process-number' : 'process-number-unfilled'}>1</div>
                      <div className="flex flex-col">
                          <p className={"order-process-title"}>Contact Details</p>
                          <p className="order-process-subtitle">Primary handler’s information</p>
                      </div>
                      
                  </div>
                  <div className="order-process-content">
                  <div className={payment ? 'process-number' : 'process-number-unfilled'}>2</div>
                      <div className="flex flex-col">
                          <p className="order-process-title">Business Details</p>
                          <p className="order-process-subtitle">Relevant company information</p>
                      </div>
                      
                  </div>
                  <div className="order-process-content">
                  <div className={completeOrder ? 'process-number' : 'process-number-unfilled'}>3</div>
                      <div className="flex flex-col">
                          <p className="order-process-title">Billing information</p>
                          <p className="order-process-subtitle">Payment details</p>
                      </div>
                      
                  </div>
              </div>
          </section>
      </>
    )
  }
  
  export default CustomerCreationProcess;